import { environment } from './../../../../environments/environment.qual';
import { UiService } from './../../../shared/services/ui/ui.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { Subscription } from 'rxjs';

export interface DialogData {
  url: string;
}

@Component({
  selector: 'app-opendialog-login',
  templateUrl: './opendialog-login.component.html',
  styleUrls: ['./opendialog-login.component.scss']
})

export class OpendialogLoginComponent implements OnInit {
  resultMessage: any;
  userInfo: string;
  signup = false;
  load = false;
  userRS: SocialUser;
  loggedIn: boolean;
  googleId = environment.idGoogle;

  private subscription = new Subscription();

  constructor(
    public dialog: MatDialog,
    private authService: AuthService,
    private socialAuthService: SocialAuthService,
    private dataService: DataService,
    private router: Router,
    public dialogRef: MatDialogRef<OpendialogLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private uiSrv: UiService
  ) {

  }


  ngOnInit(): void {
    this.initSub();
  }

  initSub() {
    this.subscription.add(
      this.authService.errorNoAccountGoogle.subscribe((valueUser) => {
        if (valueUser) {
          this.userRS = valueUser;
          this.dataService.jsonResauxSocial$.next(valueUser);
          this.signup = true;
          this.load = false;
        }
      })
    )

    this.subscription.add(
      this.authService.isAuthWithGoogle.subscribe((value) => {
        if (value) this.load = true;
      })
    )
  }

  decodeJwtResponse(token) {
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload)
  }

  loginWithSocialMedia(platform: string): void {
    if (platform === 'google') {
      this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
    } else {
      // Check if on mobile
      const platformChoice = {
        'facebook': FacebookLoginProvider.PROVIDER_ID,
        'google': GoogleLoginProvider.PROVIDER_ID,
        'apple': 'apple',
      };

      platform = platformChoice[platform];

      const platformType = platform.toLocaleLowerCase();
      this.socialAuthService.signIn(platform).then(
        (response) => {
          this.load = true;
          this.dataService.jsonResauxSocial$.next(response);
          this.socialLogin(response, platform, this.data?.url);
        },
        (error) => {
          this.resultMessage = error;
        });
    }

  }

  socialLogin(socialUser: SocialUser, platformType: string, url: string): void {
    this.dataService.jsonResauxSocial$.next(socialUser);

    this.userRS = socialUser;
    this.authService.loginSocial(socialUser.authToken, socialUser.id, platformType, socialUser.email).subscribe(res => {
      if (platformType === 'google') {
        this.authService.isAuthWithGoogle.next(true);
      }
      const userInfos = this.authService.getDecodedToken();
      const baseUrl = url ? url : '/';
      this.router.navigate([baseUrl]);
      this.load = false;

    },
      err => {
        if (err.error.error === 'invalid_grant') {
          this.signup = true;
          this.load = false;
        } else if (err.error.error === "invalid_request") {
          this.signup = false;
          this.dialogRef.close();
          this.uiSrv.showSnackbar("Connexion impossible. Veuillez réessayer.");
        }
      });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscription.unsubscribe();
  }
}

